import { Box } from '@mui/material';

export const Divider = (props: any) => (
  <Box {...props}>
    <hr
      style={{
        marginBottom: '1em',
        marginTop: '1em',
        border: 'none',
        height: '0.5px',
        width: '100%',
        color: '#DDD',
        backgroundColor: '#DDD',
      }}
    />
  </Box>
);
